import { EntityType } from "@mapmycustomers/shared";

import EntityTypesSupportedInSkippedRecords from "@app/types/dashboard/cards/skippedRecords/EntityTypesSupportedInSkippedRecords";

// Entity types a Skipped Records card can analyze, in display order.
export const SKIPPED_RECORDS_ENTITY_TYPES: EntityTypesSupportedInSkippedRecords[] = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
];
